import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ReversalTransactionState {
  account_id: string;
  account_name: string;
  amount: string;
  description: string;
  receipt_url: string;
  errors: Record<string, string>;
  loading: boolean;
}

const initialState: ReversalTransactionState = {
  account_id: '',
  account_name: '',
  amount: '',
  description: '',
  receipt_url: '',
  errors: {},
  loading: false,
};

const reversalTransactionSlice = createSlice({
  name: 'reversalTransaction',
  initialState,
  reducers: {
    setAccountData: (state, action: PayloadAction<{ id: string; name: string }>) => {
      state.account_id = action.payload.id;
      state.account_name = action.payload.name;
      if (state.errors.account_id) delete state.errors.account_id;
    },
    setAmount: (state, action: PayloadAction<string>) => {
      state.amount = action.payload;
      if (state.errors.amount) delete state.errors.amount;
    },
    setDescription: (state, action: PayloadAction<string>) => {
      state.description = action.payload;
      if (state.errors.description) delete state.errors.description;
    },
    setReceiptUrl: (state, action: PayloadAction<string>) => {
      state.receipt_url = action.payload;
    },
    setErrors: (state, action: PayloadAction<Record<string, string>>) => {
      state.errors = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    resetForm: (state) => {
      return initialState;
    },
  },
});

export const {
  setAccountData,
  setAmount,
  setDescription,
  setReceiptUrl,
  setErrors,
  setLoading,
  resetForm,
} = reversalTransactionSlice.actions;

export default reversalTransactionSlice.reducer;